import * as React from "react"

const downloadStoreLogoStyle = {
    maxHeight: '70px'
}

function MCDownload(props) {

    return (<div className="h-96 p-10 flex flex-row place-content-center items-center">

            <a className="mr-10" href={props.appStoreLink} >
                <img alt="Download Magicrop for iOS iPad from AppStore" style={downloadStoreLogoStyle} src={props.appStoreLogo}/></a>
            <a className="mr-10" href={props.macAppStoreLink} >
                <img alt="Download Magicrop for MacOS from Mac AppStore" style={downloadStoreLogoStyle} src={props.macAppStoreLogo}/></a>
            </div>)
}

export default MCDownload